module.exports = "/virtual-football-league/img/amblems/left/logos/REAL SOCIEDAD.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/REAL SOCIEDAD.png
// module id = 2117
// module chunks = 4